import { createQuery } from './core';
// PUBLIC API
export const getPaginatedUsers = createQuery('operations/get-paginated-users', ['User']);
// PUBLIC API
export const getUserActivityStats = createQuery('operations/get-user-activity-stats', ['UserDailyActivity']);
// PUBLIC API
export const getCurrentUserRole = createQuery('operations/get-current-user-role', ['User']);
// PUBLIC API
export const getTradesByUser = createQuery('operations/get-trades-by-user', ['User', 'Trade', 'TradeTag', 'Account', 'AccountGroup', 'TradeCustomFieldDefinition', 'TradeCustomFieldValue', 'TradingStrategy']);
// PUBLIC API
export const getTradeMetrics = createQuery('operations/get-trade-metrics', ['User', 'Trade', 'TradeTag', 'Account', 'AccountGroup', 'TradeCustomFieldDefinition', 'TradeCustomFieldValue', 'TradingStrategy']);
// PUBLIC API
export const getTradeById = createQuery('operations/get-trade-by-id', ['User', 'Trade', 'TradeTag', 'Account', 'TradeCustomFieldDefinition', 'TradeCustomFieldValue']);
// PUBLIC API
export const getHistoricalPriceData = createQuery('operations/get-historical-price-data', ['User']);
// PUBLIC API
export const getAllTradesForAnalytics = createQuery('operations/get-all-trades-for-analytics', ['User', 'Trade', 'Account', 'AccountGroup', 'TradingStrategy']);
// PUBLIC API
export const getEquityBasePnl = createQuery('operations/get-equity-base-pnl', ['User', 'Trade', 'Account', 'AccountGroup']);
// PUBLIC API
export const getCSVTemplateURL = createQuery('operations/get-csvtemplate-url', ['User']);
// PUBLIC API
export const getRuleUpdatePrompts = createQuery('operations/get-rule-update-prompts', ['User', 'Account', 'PropFirmTemplate', 'PropFirmAccountType', 'PropFirmTier', 'PropFirmPhase']);
// PUBLIC API
export const getFundedPrompts = createQuery('operations/get-funded-prompts', ['User', 'Account', 'PropFirmTemplate', 'PropFirmTier']);
// PUBLIC API
export const getPredecessorCandidates = createQuery('operations/get-predecessor-candidates', ['User', 'Account', 'AccountGroup', 'PropFirmTier']);
// PUBLIC API
export const getMetaApiConnection = createQuery('operations/get-meta-api-connection', ['MetaApiConnection']);
// PUBLIC API
export const getTradovateConnections = createQuery('operations/get-tradovate-connections', ['TradovateConnection', 'TradovateSyncedAccount', 'Account', 'PropFirmTemplate', 'TradovateSocketLease']);
// PUBLIC API
export const listTradovateAccountsForImport = createQuery('operations/list-tradovate-accounts-for-import', ['TradovateConnection', 'PropFirmTemplate', 'PropFirmTier', 'TradovateSyncedAccount', 'TradovateQuotaSample', 'TradovateApiIncident', 'Account', 'AccountGroup']);
// PUBLIC API
export const getTradovateDiscoveredAccounts = createQuery('operations/get-tradovate-discovered-accounts', ['TradovateConnection', 'TradovateDiscoveredAccount', 'TradovateSyncedAccount']);
// PUBLIC API
export const getPayoutSuggestions = createQuery('operations/get-payout-suggestions', ['PayoutSuggestion']);
// PUBLIC API
export const getCashMovementQuestions = createQuery('operations/get-cash-movement-questions', ['CashMovementQuestion']);
// PUBLIC API
export const getAccountResetSuggestions = createQuery('operations/get-account-reset-suggestions', ['AccountResetSuggestion', 'Account']);
// PUBLIC API
export const getAccountsByUser = createQuery('operations/get-accounts-by-user', ['User', 'Account', 'AccountGroup', 'Trade', 'Payout', 'PropFirmTemplate', 'PropFirmAccountType', 'PropFirmTier', 'PropFirmPhase', 'AccountCharge', 'TradingStrategy', 'TradovateSyncedAccount']);
// PUBLIC API
export const getPropFirmAccountsForAnalytics = createQuery('operations/get-prop-firm-accounts-for-analytics', ['User', 'Account', 'Payout', 'AccountCharge', 'PropFirmTemplate']);
// PUBLIC API
export const getAccountGroupsByUser = createQuery('operations/get-account-groups-by-user', ['User', 'AccountGroup', 'Account', 'Trade', 'Payout', 'PropFirmTemplate', 'PropFirmAccountType', 'PropFirmTier', 'PropFirmPhase', 'TradovateSyncedAccount']);
// PUBLIC API
export const getPropFirmTemplates = createQuery('operations/get-prop-firm-templates', ['User', 'PropFirmTemplate', 'PropFirmAccountType', 'PropFirmTier', 'PropFirmPhase']);
// PUBLIC API
export const getAdminPropFirmTemplates = createQuery('operations/get-admin-prop-firm-templates', ['User', 'PropFirmTemplate', 'PropFirmAccountType', 'PropFirmTier', 'PropFirmPhase']);
// PUBLIC API
export const getBlogPosts = createQuery('operations/get-blog-posts', ['BlogPost', 'BlogCategory']);
// PUBLIC API
export const getBlogPost = createQuery('operations/get-blog-post', ['BlogPost', 'BlogCategory']);
// PUBLIC API
export const getBlogCategories = createQuery('operations/get-blog-categories', ['BlogCategory', 'BlogPost']);
// PUBLIC API
export const getAdminBlogPosts = createQuery('operations/get-admin-blog-posts', ['BlogPost', 'BlogCategory']);
// PUBLIC API
export const getComparatorOffers = createQuery('operations/get-comparator-offers', ['ComparatorFirm', 'ComparatorOffer']);
// PUBLIC API
export const getAdminComparatorFirms = createQuery('operations/get-admin-comparator-firms', ['ComparatorFirm']);
// PUBLIC API
export const getAdminComparatorOffers = createQuery('operations/get-admin-comparator-offers', ['ComparatorOffer']);
// PUBLIC API
export const getPublishedFaq = createQuery('operations/get-published-faq', ['FaqCategory', 'FaqItem']);
// PUBLIC API
export const getAdminFaqCategories = createQuery('operations/get-admin-faq-categories', ['FaqCategory', 'FaqItem']);
// PUBLIC API
export const getAdminFaqItems = createQuery('operations/get-admin-faq-items', ['FaqItem', 'FaqCategory']);
// PUBLIC API
export const getPayoutsByAccount = createQuery('operations/get-payouts-by-account', ['User', 'Account', 'Payout']);
// PUBLIC API
export const getRecentPayoutsForUser = createQuery('operations/get-recent-payouts-for-user', ['User', 'Payout', 'Account', 'AccountAttachment']);
// PUBLIC API
export const getTptWalletContext = createQuery('operations/get-tpt-wallet-context', ['User', 'Account', 'PropFirmTemplate', 'PropFirmWallet', 'AccountGroup']);
// PUBLIC API
export const getWalletByPropFirm = createQuery('operations/get-wallet-by-prop-firm', ['User', 'PropFirmWallet', 'PropFirmTemplate', 'WalletTransfer', 'WalletWithdrawal', 'Account']);
// PUBLIC API
export const getAccountChargesByUser = createQuery('operations/get-account-charges-by-user', ['User', 'AccountCharge', 'AccountChargeOccurrence', 'Account']);
// PUBLIC API
export const getAccountById = createQuery('operations/get-account-by-id', ['User', 'Account', 'AccountGroup', 'Trade', 'Payout', 'PropFirmTemplate', 'PropFirmAccountType', 'PropFirmTier', 'PropFirmPhase', 'MetaApiConnection', 'TradovateSyncedAccount']);
// PUBLIC API
export const getAccountGroupById = createQuery('operations/get-account-group-by-id', ['User', 'AccountGroup', 'Account', 'Trade', 'Payout', 'PropFirmTemplate', 'PropFirmAccountType', 'PropFirmTier', 'PropFirmPhase', 'TradovateSyncedAccount']);
// PUBLIC API
export const getLiteModeAccess = createQuery('operations/get-lite-mode-access', ['User']);
// PUBLIC API
export const getTradingStrategiesByUser = createQuery('operations/get-trading-strategies-by-user', ['User', 'TradingStrategy']);
// PUBLIC API
export const getActivePlaybook = createQuery('operations/get-active-playbook', ['User', 'Playbook']);
// PUBLIC API
export const getPlaybookVersions = createQuery('operations/get-playbook-versions', ['User', 'Playbook']);
// PUBLIC API
export const getPlaybooks = createQuery('operations/get-playbooks', ['User', 'Playbook', 'Account', 'AccountGroup']);
// PUBLIC API
export const getPropFirmRulesForAccount = createQuery('operations/get-prop-firm-rules-for-account', ['User', 'Account', 'PropFirmTier', 'PropFirmPhase']);
// PUBLIC API
export const getEdgeReports = createQuery('operations/get-edge-reports', ['User', 'EdgeReport']);
// PUBLIC API
export const getEdgeReportById = createQuery('operations/get-edge-report-by-id', ['User', 'EdgeReport']);
// PUBLIC API
export const getEdgyCreditState = createQuery('operations/get-edgy-credit-state', ['User', 'EdgyCredit']);
// PUBLIC API
export const getEdgyReadiness = createQuery('operations/get-edgy-readiness', ['User', 'Playbook', 'Trade']);
// PUBLIC API
export const getMyEdgeReports = createQuery('operations/get-my-edge-reports', ['User', 'EdgeReport', 'Playbook']);
// PUBLIC API
export const getAccountAttachments = createQuery('operations/get-account-attachments', ['User', 'Account', 'AccountAttachment']);
// PUBLIC API
export const getAccountAttachmentSignedURL = createQuery('operations/get-account-attachment-signed-url', ['User', 'AccountAttachment']);
// PUBLIC API
export const getMySocialReports = createQuery('operations/get-my-social-reports', ['SocialReport']);
// PUBLIC API
export const getSocialReport = createQuery('operations/get-social-report', ['Account', 'AccountGroup', 'PropFirmTemplate', 'TradingStrategy', 'Trade', 'Payout', 'AccountCharge', 'AccountChargeOccurrence', 'TradingSession', 'SocialReport']);
// PUBLIC API
export const getSocialReportThumbnailUrl = createQuery('operations/get-social-report-thumbnail-url', ['SocialReport']);
// PUBLIC API
export const getSocialReportSignedUrls = createQuery('operations/get-social-report-signed-urls', ['SocialReport']);
// PUBLIC API
export const getMyNotifications = createQuery('operations/get-my-notifications', ['User', 'Notification', 'MentorNotification', 'TradovateDiscoveredAccount']);
// PUBLIC API
export const getTradeCustomFieldDefinitions = createQuery('operations/get-trade-custom-field-definitions', ['User', 'TradeCustomFieldDefinition']);
// PUBLIC API
export const getTradeTagSuggestions = createQuery('operations/get-trade-tag-suggestions', ['User', 'TradeTagSuggestion']);
// PUBLIC API
export const getTradeTagsByUser = createQuery('operations/get-trade-tags-by-user', ['User', 'TradeTag']);
// PUBLIC API
export const getTradeColumnPreferences = createQuery('operations/get-trade-column-preferences', ['User', 'TradeColumnPreference']);
// PUBLIC API
export const getMyLayouts = createQuery('operations/get-my-layouts', ['User', 'DashboardLayout', 'DashboardRow', 'DashboardSlot']);
// PUBLIC API
export const getActiveLayout = createQuery('operations/get-active-layout', ['User', 'DashboardLayout', 'DashboardRow', 'DashboardSlot']);
// PUBLIC API
export const getLayoutByShareToken = createQuery('operations/get-layout-by-share-token', ['User', 'DashboardLayout', 'DashboardRow', 'DashboardSlot']);
// PUBLIC API
export const getEdgelyLayouts = createQuery('operations/get-edgely-layouts', ['DashboardLayout', 'DashboardRow', 'DashboardSlot']);
// PUBLIC API
export const getAdminLayouts = createQuery('operations/get-admin-layouts', ['DashboardLayout', 'DashboardRow', 'DashboardSlot', 'User']);
// PUBLIC API
export const getCommunityLayouts = createQuery('operations/get-community-layouts', ['DashboardLayout', 'DashboardRow', 'DashboardSlot', 'User']);
// PUBLIC API
export const getLayoutById = createQuery('operations/get-layout-by-id', ['DashboardLayout', 'DashboardRow', 'DashboardSlot']);
// PUBLIC API
export const getCustomPages = createQuery('operations/get-custom-pages', ['User', 'CustomPage']);
// PUBLIC API
export const getCustomPageById = createQuery('operations/get-custom-page-by-id', ['User', 'CustomPage', 'DashboardLayout', 'DashboardRow', 'DashboardSlot']);
// PUBLIC API
export const getRoutinesByUser = createQuery('operations/get-routines-by-user', ['User', 'TradingRoutine', 'RoutineCompletion']);
// PUBLIC API
export const getGoalsByUser = createQuery('operations/get-goals-by-user', ['User', 'TradingGoal', 'GoalPeriodHistory']);
// PUBLIC API
export const getNotebooksByUser = createQuery('operations/get-notebooks-by-user', ['User', 'Notebook', 'NotebookCategory']);
// PUBLIC API
export const getNotebookById = createQuery('operations/get-notebook-by-id', ['User', 'Notebook', 'NotebookCategory']);
// PUBLIC API
export const getNotebookCategoriesByUser = createQuery('operations/get-notebook-categories-by-user', ['User', 'NotebookCategory']);
// PUBLIC API
export const searchNotebooks = createQuery('operations/search-notebooks', ['User', 'Notebook', 'NotebookCategory']);
// PUBLIC API
export const searchAnalyses = createQuery('operations/search-analyses', ['User', 'Notebook']);
// PUBLIC API
export const getAnalysesByUser = createQuery('operations/get-analyses-by-user', ['User', 'Notebook']);
// PUBLIC API
export const getActiveTradingSession = createQuery('operations/get-active-trading-session', ['User', 'TradingSession']);
// PUBLIC API
export const getTradingSessionsByUser = createQuery('operations/get-trading-sessions-by-user', ['User', 'TradingSession', 'SessionError']);
// PUBLIC API
export const getTradingSessionById = createQuery('operations/get-trading-session-by-id', ['User', 'TradingSession', 'SessionError', 'MentorNote']);
// PUBLIC API
export const getPendingSessionMerges = createQuery('operations/get-pending-session-merges', ['PendingSessionMerge', 'TradingSession']);
// PUBLIC API
export const getSessionByShareToken = createQuery('operations/get-session-by-share-token', ['TradingSession', 'SessionError']);
// PUBLIC API
export const getSessionErrors = createQuery('operations/get-session-errors', ['SessionError']);
// PUBLIC API
export const getTradingNoteTemplatesByUser = createQuery('operations/get-trading-note-templates-by-user', ['User', 'TradingNoteTemplate']);
// PUBLIC API
export const getCustomerPortalUrl = createQuery('operations/get-customer-portal-url', ['User']);
// PUBLIC API
export const getB2bPartnersAdmin = createQuery('operations/get-b2b-partners-admin', ['B2bPartner', 'B2bGrant']);
// PUBLIC API
export const getB2bGrantsAdmin = createQuery('operations/get-b2b-grants-admin', ['B2bPartner', 'B2bGrant', 'User']);
// PUBLIC API
export const getMyB2bGrantInfo = createQuery('operations/get-my-b2b-grant-info', ['B2bGrant', 'B2bPartner']);
// PUBLIC API
export const getMyAffiliateProfile = createQuery('operations/get-my-affiliate-profile', ['User', 'AffiliateProfile']);
// PUBLIC API
export const getMyAffiliateDashboard = createQuery('operations/get-my-affiliate-dashboard', ['User', 'AffiliateProfile', 'AffiliateClick', 'AffiliateCommission', 'AffiliatePayout']);
// PUBLIC API
export const getAffiliateBrandingAssets = createQuery('operations/get-affiliate-branding-assets', ['User', 'AffiliateProfile', 'AffiliateAsset']);
// PUBLIC API
export const getAdminAffiliates = createQuery('operations/get-admin-affiliates', ['User', 'AffiliateProfile', 'AffiliateClick', 'AffiliateCommission']);
// PUBLIC API
export const getAdminAffiliatePayouts = createQuery('operations/get-admin-affiliate-payouts', ['User', 'AffiliatePayout', 'AffiliateCommission']);
// PUBLIC API
export const getAllFilesByUser = createQuery('operations/get-all-files-by-user', ['User', 'File']);
// PUBLIC API
export const getDownloadFileSignedURL = createQuery('operations/get-download-file-signed-url', ['User', 'File']);
// PUBLIC API
export const getDailyStats = createQuery('operations/get-daily-stats', ['User', 'DailyStats']);
// PUBLIC API
export const getAdminUsersByPlan = createQuery('operations/get-admin-users-by-plan', ['User']);
// PUBLIC API
export const getAdminBrokerHealth = createQuery('operations/get-admin-broker-health', ['User', 'TradovateConnection', 'MetaApiConnection']);
// PUBLIC API
export const getAdminUserDetail = createQuery('operations/get-admin-user-detail', ['User', 'Account']);
// PUBLIC API
export const getAdminTradovateQuota = createQuery('operations/get-admin-tradovate-quota', ['User', 'TradovateConnection', 'TradovateSyncedAccount']);
// PUBLIC API
export const getAdminTradovateQuotaHistory = createQuery('operations/get-admin-tradovate-quota-history', ['User', 'TradovateQuotaSample']);
// PUBLIC API
export const getAdminBetaDiagnostic = createQuery('operations/get-admin-beta-diagnostic', ['User', 'TradovateConnection', 'TradovateSocketLease', 'TradovateQuotaSample', 'TradovateShadowDiff', 'TradovateWsLatency', 'Trade']);
// PUBLIC API
export const getAdminTradovateEndpointBreakdown = createQuery('operations/get-admin-tradovate-endpoint-breakdown', ['User', 'TradovateQuotaSample', 'Account', 'TradovateShadowDiff', 'TradovateSyncedAccount', 'TradovateWsLatency']);
// PUBLIC API
export const getAdminTradovateReauth = createQuery('operations/get-admin-tradovate-reauth', ['User', 'TradovateConnection', 'TradovateWsReauthEvent']);
// PUBLIC API
export const getAdminTradovateBackfillRepair = createQuery('operations/get-admin-tradovate-backfill-repair', ['User', 'Trade', 'TradovateSyncedAccount', 'Account', 'TradovateConnection']);
// PUBLIC API
export const getAdminTradovateErrors = createQuery('operations/get-admin-tradovate-errors', ['User', 'TradovateApiIncident', 'TradovateQuotaSample']);
// PUBLIC API
export const getMyStudents = createQuery('operations/get-my-students', ['User', 'MentorRelation', 'StudentPermissions']);
// PUBLIC API
export const getMyInvitations = createQuery('operations/get-my-invitations', ['User', 'MentorInvitation']);
// PUBLIC API
export const getMyMentorNotifications = createQuery('operations/get-my-mentor-notifications', ['User', 'MentorNotification', 'MentorRelation', 'MentorInvitation']);
// PUBLIC API
export const getStudentTrades = createQuery('operations/get-student-trades', ['User', 'MentorRelation', 'StudentPermissions', 'Trade', 'TradeTag', 'Account', 'AccountGroup', 'TradeCustomFieldDefinition', 'TradeCustomFieldValue', 'MentorNote']);
// PUBLIC API
export const getStudentSessions = createQuery('operations/get-student-sessions', ['User', 'MentorRelation', 'StudentPermissions', 'TradingSession', 'MentorNote']);
// PUBLIC API
export const getStudentSessionById = createQuery('operations/get-student-session-by-id', ['User', 'MentorRelation', 'StudentPermissions', 'TradingSession', 'MentorNote']);
// PUBLIC API
export const getStudentAnalyticsTrades = createQuery('operations/get-student-analytics-trades', ['User', 'MentorRelation', 'StudentPermissions', 'Trade', 'Account']);
// PUBLIC API
export const getStudentAccounts = createQuery('operations/get-student-accounts', ['User', 'MentorRelation', 'StudentPermissions', 'Account', 'AccountGroup', 'PropFirmTemplate']);
// PUBLIC API
export const getStudentSessionAccounts = createQuery('operations/get-student-session-accounts', ['User', 'MentorRelation', 'StudentPermissions', 'Account', 'AccountGroup', 'PropFirmTemplate', 'Trade', 'Payout']);
// PUBLIC API
export const getStudentPayouts = createQuery('operations/get-student-payouts', ['User', 'MentorRelation', 'StudentPermissions', 'Payout', 'Account']);
// PUBLIC API
export const getStudentAccountGroups = createQuery('operations/get-student-account-groups', ['User', 'MentorRelation', 'StudentPermissions', 'AccountGroup', 'Account']);
// PUBLIC API
export const getStudentRoutines = createQuery('operations/get-student-routines', ['User', 'MentorRelation', 'StudentPermissions', 'TradingRoutine', 'RoutineCompletion']);
// PUBLIC API
export const getStudentGoals = createQuery('operations/get-student-goals', ['User', 'MentorRelation', 'StudentPermissions', 'TradingGoal', 'GoalPeriodHistory']);
// PUBLIC API
export const getStudentEquityBasePnl = createQuery('operations/get-student-equity-base-pnl', ['User', 'Trade', 'Account', 'MentorRelation', 'StudentPermissions']);
// PUBLIC API
export const getStudentStrategies = createQuery('operations/get-student-strategies', ['User', 'TradingStrategy', 'MentorRelation', 'StudentPermissions']);
// PUBLIC API
export const getMentorNotesForSession = createQuery('operations/get-mentor-notes-for-session', ['User', 'MentorRelation', 'MentorNote']);
// PUBLIC API
export const getMentorNotesForTrade = createQuery('operations/get-mentor-notes-for-trade', ['User', 'MentorRelation', 'MentorNote']);
// PUBLIC API
export const getGlobalMentorNotes = createQuery('operations/get-global-mentor-notes', ['User', 'MentorRelation', 'MentorNote']);
// PUBLIC API
export const getStudentMentorNotes = createQuery('operations/get-student-mentor-notes', ['User', 'MentorRelation', 'MentorNote']);
// PUBLIC API
export const getMyMentors = createQuery('operations/get-my-mentors', ['User', 'MentorRelation', 'StudentPermissions', 'MentorInvitation']);
// PUBLIC API
export const getInvitationByToken = createQuery('operations/get-invitation-by-token', ['User', 'MentorInvitation']);
// PUBLIC API
export const getNewsItems = createQuery('operations/get-news-items', []);
// PUBLIC API
export const getInterestRates = createQuery('operations/get-interest-rates', ['InterestRate']);
// PUBLIC API
export const getEconomicCalendar = createQuery('operations/get-economic-calendar', ['EconomicEvent']);
// PUBLIC API
export const getEarningsCalendar = createQuery('operations/get-earnings-calendar', ['EarningsEvent']);
// PRIVATE API (used in SDK)
export { buildAndRegisterQuery } from './core';
//# sourceMappingURL=index.js.map